export const Title = "充電サービス管理画面";

// サーバーURL
export const DEV = "https://core-api.gx.dev.mo-t.com/";
export const QA = "https://core-api.gx.qa.mo-t.com/";
export const MAIN = "https://core-api.gx.mo-t.com/";

// タクモニログイン画面
// ※タクモニログインがなくなる時に削除
export const DEV_MONITOR = "https://monitor.dev.m-o-v.jp/login";
export const QA_MONITOR = "https://monitor.qa.m-o-v.jp/login";
export const MAIN_MONITOR = "https://monitor.m-o-v.jp/login";

// 事故報告フォーム
export const DEV_ACCIDENT_REPORT_FORM_URL = "https://forms.gle/jon2EoEtDP1nFJ1H6";
export const QA_ACCIDENT_REPORT_FORM_URL = "https://forms.gle/Jry6DKmw5PyeESFr8";
export const MAIN_ACCIDENT_REPORT_FORM_URL = "https://forms.gle/ZcYJZiMGyeyzEztU9";

export function GetAccidentReportFormUrl() {
  switch (process.env.REACT_APP_PROD_URL) {
    case MAIN:
      return MAIN_ACCIDENT_REPORT_FORM_URL;
    case QA:
      return QA_ACCIDENT_REPORT_FORM_URL;
    default:
      return DEV_ACCIDENT_REPORT_FORM_URL;
  }
}

// GO Charge 地図画面
export const DEV_GO_CHARGE_MAP_URL = "https://dev.go-charge.jp/";
export const QA_GO_CHARGE_MAP_URL = "https://qa.go-charge.jp/";
export const MAIN_GO_CHARGE_MAP_URL = "https://go-charge.jp/";

export function GetGoChargeMapUrl() {
  switch (process.env.REACT_APP_PROD_URL) {
    case MAIN:
      return MAIN_GO_CHARGE_MAP_URL;
    case QA:
      return QA_GO_CHARGE_MAP_URL;
    default:
      return DEV_GO_CHARGE_MAP_URL;
  }
}

// GO Charge 申し込みフォーム
export const DEV_GO_CHARGE_APPLICATION_FORM_URL = "https://32263817.form.kintoneapp.com/public/a9f5204f2caec839ffd61da1ce03e5118832ce6135d6ed7585f5eafb7c0a9297";
export const QA_GO_CHARGE_APPLICATION_FORM_URL = "https://32263817.form.kintoneapp.com/public/a9f5204f2caec839ffd61da1ce03e5118832ce6135d6ed7585f5eafb7c0a9297";
export const MAIN_GO_CHARGE_APPLICATION_FORM_URL = "https://32263817.form.kintoneapp.com/public/a9f5204f2caec839ffd61da1ce03e5118832ce6135d6ed7585f5eafb7c0a9297";

export function GetGoChargeApplicationFormUrl() {
  switch (process.env.REACT_APP_PROD_URL) {
    case MAIN:
      return MAIN_GO_CHARGE_APPLICATION_FORM_URL;
    case QA:
      return QA_GO_CHARGE_APPLICATION_FORM_URL;
    default:
      return DEV_GO_CHARGE_APPLICATION_FORM_URL;
  }
}

// Cookie値
export const SINGLE_OFFICE_ID = "office_id";
export const MULTI_OFFICE_ID = "office_ids";

export const CommonConstants = {
  Search: "検索",
  Register: "登録",
  Save: "保存",
  BackToList: "一覧へ戻る",
  Return: "戻る",
  Detail: "詳細",
  Edit: "編集",
  Cancel: "キャンセル",
  Replace: "更新",
  Delete: "削除",
  Singup: "新規登録",
  BatchExecution: "一括実行",
  ResetSearchCriteria: "検索条件をリセット",
  CompanyOffice: "会社／営業所",
  Add: "追加",
  DownloadCSV: "CSVダウンロード",
  RegisterReason: "理由登録",
} as const;

export interface ErrorResponse {
  message: string;
}

export const ChargeAmountAnnot = `※ 本画面に表示される充電電力量は速報値です\n※ 確定値は請求書にてご確認ください`;
